import { useState, useEffect, useRef } from 'react';
const COUNTDWON_NUM = 60;

let timer: NodeJS.Timeout;

export const useCountDown = () => {
  const [countDown, setCountDown] = useState<number>(-1);
  const [isDisposed, setIsDisposed] = useState<boolean>(false);
  const count = useRef<number>(COUNTDWON_NUM);

  // 退出时清除倒计时
  useEffect(() => {
    return () => {
      clearInterval(timer);
    };
  }, []);

  // 开始倒计时
  const startCountDown = (_count = COUNTDWON_NUM) => {
    count.current = _count;
    setCountDown(_count);

    if (timer) {
      clearInterval(timer);
    }

    timer = setInterval(() => {
      if (count.current > 0) {
        setCountDown(count.current--);
      } else {
        doneCountDown();
      }
    }, 1000);
  };

  // 重置倒计时
  const doneCountDown = () => {
    setIsDisposed(true);
    clearInterval(timer);
    setCountDown(-1);
    count.current = COUNTDWON_NUM;
  };

  return {
    countDown,
    isDisposed,
    startCountDown
  };
};

export default useCountDown;
